console.log('custom.js file')
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
$(document).ready(function(){
  var getBundlebody = $('#raw-rewards .container').html();
  var getLeng = $('#modalCreateBundle').length;
  if(getLeng){
  	//$('#modalCreateBundle .modal-body').html(getBundlebody);
  }
  //$('.home-banner__sale-off').attr({"data-toggle":"modal", "data-target":"#modalCreateBundle"});
  $('.home-banner__sale-off').click(function(e){
    //e.preventDefault();
    
  });
  jQuery(document).on('click','.createBundle',function(e){
    var getE = $(this).closest('.section-start-earning__content').find('.getEmail').val();
    var getHost = window.location.hostname;
    if(getE !== ''){
    	window.location.href = 'https://'+getHost+'/pages/step-forms?email='+getE;
    }
  });
});
